// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2tCNG","imageUploader":"EGiftCard_imageUploader__2V7lq"};